import Container from "../../common/layout/Container";
import {
    faAddressCard,
    faBucket, faClipboardList,
    faCogs, faEdit,
    faMagnifyingGlassChart,
    faPeopleRoof, faPieChart,
    faToggleOn,
    faWrench
} from "@fortawesome/free-solid-svg-icons";
import "../css/insights.css"
import IconCard from "../../common/elements/IconCard";
import {useState} from "react";
import Columns from "../../common/layout/Columns";
import Column from "../../common/layout/Column";
import Button from "../../common/elements/Button";
import ReviewTemplateModal from "./ReviewTemplateModal";
import useFetchWithMsal from "../../../useFetchWithMsal";
import {thor_api_urls} from "../../common/Constants";
import UpdateInstrumentationInstructionsModal from "./UpdateInstrumentationInstructionsModal";
import Icon from "../../common/elements/Icon";

export const ExperimentMetadata = (props) => {

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isReviewModalActive, setIsReviewModalActive] = useState(false);
    const [isUpdateInstrumentationModalActive, setUpdateInstrumentationModalActive] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [isInstrumentationReview, setIsInstrumentationReview] = useState(false);
    const [modalExperimentState, setModalExperimentState] = useState('');
    const {executeHtml} = useFetchWithMsal();

    function changeIsCollapsedFlag() {
        setIsCollapsed(!isCollapsed)
    }

    function buildColumn(key, value, className = "is-half") {
        return <Column className={className + " fa-border ml--1 mt--1"}>
          <span
              className="has-text-weight-bold">{key}</span>
            <span
                className="fa-pull-right">{value}</span>
        </Column>
    }

    function resolveUserReshuffleType(value) {
        return value ? "Daily" : "None"
    }

    function resolveMemberTest(value) {
        return value ? "Member-based Test" : "Unique User Test"
    }

    function resolveBoolean(value) {
        return value ? capitalizeFirstLetter(value) : "False"
    }

    function resolveTimestampColumn(key, value) {
        return value ? buildColumn(key, value) : <></>
    }

    function capitalizeFirstLetter(value) {
        if(value == null)
            return ''
        const valueAsString = value.toString()
        return valueAsString.charAt(0).toUpperCase() + valueAsString.slice(1);
    }

    function arrayToCommaSeparatedString(arr) {
        console.log(arr);
        if(arr === null || arr === 'null' || arr.length === 0)
            return '';
        return arr.join(', ');
    }

    function mapOperationToString(value) {
        switch (value) {
            case 'IN':
                return 'Any value in the list';
            case 'GT':
                return 'Greater than';
            case 'GTE':
                return 'Greater than or equal to';
            case 'LT':
                return 'Less than';
            case 'LTE':
                return 'Less than or equal to';
            case 'BTWN':
                return 'Between';
            default:
                return value;
        }
    }

    function getReviewButtonConfig(experimentState) {
        const state = experimentState?.toLowerCase();
        switch (state) {
            case 'design_review':
                return {
                    text: 'Review Design',
                    action: () => handleReviewConfiguration()
                };
            case 'instrumentation':
                return {
                    text: 'Signoff on Instrumentation',
                    action: () => handleReviewInstrumentation()
                };
            case 'cleanup':
                return {
                    text: 'Signoff on Cleanup',
                    action: () => handleCodeCleanup()
                };
            default:
                return {
                    text: 'Not Allowed',
                    action: () => console.log('No action defined for state:', experimentState)
                };
        }
    }

    async function fetchExperimentReviewContent(experiment, title, templateType) {
        setModalTitle(title);
        setIsReviewModalActive(true);
        try {
            console.log(thor_api_urls.experimentReviewTemplates(experiment['key'], templateType));
            const endpoint = thor_api_urls.experimentReviewTemplates(experiment['key'], templateType);
            
            // Use executeHtml for HTML content
            const htmlContent = await executeHtml('GET', endpoint)
            setModalContent(htmlContent);
        } catch (error) {
            console.error('API call failed:', error);
            setModalContent(`<div class="notification is-danger">Failed to load content: ${error.message}</div>`);
        }
    }

    function handleReviewConfiguration() {
        console.log('Reviewing configuration for experiment:', props.experiment['key']);
        setModalExperimentState(props.experiment['state']);
        fetchExperimentReviewContent(props.experiment, 'Review Design', 'engineer_design_review');
    }

    function handleReviewInstrumentation() {
        console.log('Reviewing instrumentation for experiment:', props.experiment['key']);
        setModalExperimentState(props.experiment['state']);
        setIsInstrumentationReview(true);
        fetchExperimentReviewContent(props.experiment, 'Signoff on Instrumentation', 'engineer_instrumentation_signoff');
    }

    function handleCodeCleanup() {
        console.log('Starting code cleanup for experiment:', props.experiment['key']);
        setModalExperimentState(props.experiment['state']);
        fetchExperimentReviewContent(props.experiment, 'Signoff on Cleanup', 'engineer_cleanup_signoff');
    }

    return (
        <>
            <Container>
                <div className="card has-background-light pb-2">
                    <div className="card-content">
                        {(props.experiment['state'] && (props.experiment['state'] === 'design_review' || props.experiment['state'] === 'instrumentation' ||
                            props.experiment['state'] === 'cleanup')) && <div>
                            {(() => {
                                const buttonConfig = getReviewButtonConfig(props.experiment['state']);
                                return (
                                    <Button
                                        className={"is-pulled-right"}
                                        onClick={buttonConfig.action}
                                    >
                                        {buttonConfig.text}
                                    </Button>
                                );
                            })()}
                        </div>}
                        <Button
                            className={"is-pulled-right mr-3"}
                            onClick={() => setUpdateInstrumentationModalActive(true)}
                        >
                            <Icon icon={faEdit}/>
                            <span>Update Instrumentation Instructions</span>

                        </Button>
                        <IconCard icon={faAddressCard} title={"General"}
                        />
                        <Columns id={props.id} className={"is-multiline ml-1 mt-1 is-collapsible"}>
                            {buildColumn("Key", props.experiment['key'])}
                            {buildColumn("Source", props.experiment['source'] || 'THOR')}
                            {buildColumn("Name", props.experiment['name'] || '-')}
                            {buildColumn("Description", props.experiment['description'] || '-')}
                            {buildColumn("Type", (props.experiment['type'] || '-').toUpperCase())}
                            {buildColumn("Experiment State", capitalizeFirstLetter(props.experiment['state']))}
                            {buildColumn("Owner", props.experiment['owner'] || '-')}
                            {buildColumn("Created Date", props.experiment['createdAt'] || '-')}
                            {buildColumn("Is Archived?", resolveBoolean(props.experiment['archived']))}
                            {buildColumn("Jira Ticket", props.experiment['ticket'] || '-')}
                            {buildColumn("Spec URL", props.experiment['specification'] || '-')}
                        </Columns>
                        <br/>
                    </div>

                    <div className="card-content">
                        <IconCard icon={faCogs} title={"Metadata"}
                                  body={"Read-only view of your experiment's configuration"}
                                  isCollapsed={isCollapsed}
                                  collapse={changeIsCollapsedFlag}
                                  collapsedSubtitle={"Expand to see your experiment's configuration"}
                        />
                        {
                            isCollapsed ? <></> :
                                <>
                                    <div>
                                        <IconCard icon={faToggleOn} title={"Status"}
                                        />
                                        <Columns id={props.id} className={"is-multiline ml-1 mt-1 is-collapsible"}>
                                            {buildColumn("Development Status", capitalizeFirstLetter(props.experiment['devStatus']))}
                                            {buildColumn("Production Status", capitalizeFirstLetter(props.experiment['prodStatus']))}
                                        </Columns>
                                        <br/>
                                        <IconCard icon={faWrench} title={"Configuration"}
                                        />
                                        <Columns id={props.id} className={"is-multiline ml-1 mt-1 is-collapsible"}>
                                            {buildColumn("Traffic Allocation", props.experiment['trafficAllocation'] + "%")}
                                            {buildColumn("Salt", resolveUserReshuffleType(props.experiment['userReshuffleType']))}
                                            {buildColumn("Forced Bucket Skip Audience", resolveBoolean(props.experiment['forcedBucketsSkipAudience']))}
                                            {buildColumn("Bucketing Type", resolveMemberTest(props.experiment['memberTest']))}
                                        </Columns>
                                        <br/>

                                        {(props.experiment["buckets"] || []).length > 0 && (
                                            <div>
                                                <IconCard icon={faBucket} title={"Buckets"}
                                                />
                                                <table className={"table is-bordered is-fullwidth"}>
                                                    <thead>
                                                    <tr>
                                                        <th>Id</th>
                                                        <th>Key</th>
                                                        <th>Description</th>
                                                        <th>Traffic Allocation</th>
                                                        <th>Control</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(props.experiment["buckets"] || []).map(bucket => (
                                                        <tr>
                                                            <td>{bucket['id']}</td>
                                                            <td>{capitalizeFirstLetter(bucket['key'])}</td>
                                                            <td>{capitalizeFirstLetter(bucket['description'])}</td>
                                                            <td>{bucket['trafficAllocation']}</td>
                                                            <td>{capitalizeFirstLetter(bucket['control'])}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        <br/>

                                        {(props.experiment["experimentAudiences"] || []).length > 0 && (
                                            <div>
                                                <IconCard icon={faPeopleRoof} title={"Audiences"}
                                                />
                                                <div className={"content"}>
                                                    <strong>Description: </strong> {capitalizeFirstLetter(props.experiment['audienceDescription'])}
                                                </div>
                                                <table className={"table is-bordered is-fullwidth"}>
                                                    <thead>
                                                    <tr>
                                                        <th>Audience</th>
                                                        <th>Attribute Name</th>
                                                        <th>Attribute Value</th>
                                                        <th>Type</th>
                                                        <th>Strict</th>
                                                        <th>Operation</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(props.experiment["experimentAudiences"] || []).map(experimentAudience => (
                                                        <tr>
                                                            <td>{capitalizeFirstLetter(experimentAudience['audienceName'])}</td>
                                                            <td>{experimentAudience['attributeName']}</td>
                                                            <td>{experimentAudience['attributeValues']}</td>
                                                            <td>{experimentAudience['exclude'] ? 'Exclude' : 'Include'}</td>
                                                            <td>{capitalizeFirstLetter(experimentAudience['strict'].toString())}</td>
                                                            <td>{mapOperationToString(experimentAudience['operation'].toString())}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        <br/>

                                        {(props.experiment["segments"] || []).length > 0 && (
                                            <div>
                                                <IconCard icon={faPieChart} title={"Segments"}
                                                />
                                                <Columns id={props.id} className={"is-multiline ml-1 mt-1 is-collapsible"}>
                                                    {(props.experiment["segments"] || []).map(segment =>
                                                        buildColumn(segment['segmentName'], '','is-one-fifth')
                                                    )}
                                                </Columns>
                                                <br/>
                                            </div>
                                        )}

                                        {(props.experiment["instrumentationInstructions"] && Object.keys(props.experiment["instrumentationInstructions"]).length > 0) && (
                                            <div>
                                                <IconCard icon={faClipboardList} title={"Instrumentation Instructions"}
                                                />
                                                <table className={"table is-bordered is-fullwidth"}>
                                                    <colgroup>
                                                        <col style={{width: '30%'}} />
                                                        <col style={{width: '70%'}} />
                                                    </colgroup>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Instrumentation Pattern</th>
                                                            <td>{props.experiment['instrumentationInstructions']['instrumentationPattern']}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Instrumentation Sources</th>
                                                            <td>{arrayToCommaSeparatedString(props.experiment['instrumentationInstructions']['instrumentationSources'])}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Impacted Services</th>
                                                            <td>{arrayToCommaSeparatedString(props.experiment['instrumentationInstructions']['impactedServices'])}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Pages Under Test</th>
                                                            <td>{arrayToCommaSeparatedString(props.experiment['instrumentationInstructions']['pagesUnderTest'])}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Percentage of Traffic Exposed on Impacted Pages</th>
                                                            <td>{props.experiment['instrumentationInstructions']['expectedTrafficExposure']}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Custom Eligibility Checks</th>
                                                            <td>{props.experiment['instrumentationInstructions']['customEligibilityChecks']}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br/>
                                            </div>
                                        )}

                                        <IconCard icon={faMagnifyingGlassChart} title={"Analysis"}
                                        />
                                        <Columns id={props.id} className={"is-multiline ml-1 mt-1 is-collapsible"}>
                                            {buildColumn("Bucket Comparison Mode", capitalizeFirstLetter(props.experiment['bucketComparisonsMode']))}
                                            {buildColumn("Salt", resolveUserReshuffleType(props.experiment['userReshuffleType']))}
                                            {buildColumn("Is Analysis Required?", resolveBoolean(props.experiment['analysisRequired']))}
                                            {buildColumn("Is Long Running?", resolveBoolean(props.experiment['longRunning']))}
                                            {resolveTimestampColumn("Start Analysis Date", props.experiment['analysisStartDate'])}
                                            {resolveTimestampColumn("End Analysis Date", props.experiment['analysisEndDate'])}
                                            {resolveTimestampColumn("Last Reset Timestamp", props.experiment['lastResetTimestamp'])}
                                        </Columns>
                                        <br/>
                                    </div>
                                </>
                        }
                    </div>
                </div>

                <ReviewTemplateModal
                    isActive={isReviewModalActive}
                    title={modalTitle}
                    content={modalContent}
                    onClose={() => setIsReviewModalActive(false)}
                    experimentKey={props.experiment?.key}
                    experimentState={modalExperimentState}
                    instrumentationInstructions={props.experiment?.instrumentationInstructions}
                    showInstrumentationProperties={isInstrumentationReview}
                    onSuccess={() => {
                        // Refresh the page or refetch data to show updated review status
                        window.location.reload();
                    }}
                />
                <UpdateInstrumentationInstructionsModal
                    isActive={isUpdateInstrumentationModalActive}
                    onClose={() => setUpdateInstrumentationModalActive(false)}
                    instrumentationInstructions={props.experiment?.instrumentationInstructions}
                    experimentKey={props.experiment?.key}
                    onSuccess={() => {
                        // Refresh the page or refetch data to show updated instrumentation instructions
                        window.location.reload();
                    }}
                />
            </Container>
        </>

    );
}